import React from 'react';
export const LoadingState = ({ count = 10 }) => {
    return (React.createElement("div", { className: "grid grid-cols-1 gap-1" }, [...Array(count)].map((_e, idx) => (React.createElement("div", { key: idx, className: "flex space-s-3 items-center p-2 animate-pulse" },
        React.createElement("div", { className: "rounded-full bg-skeleton h-10 w-10" }),
        React.createElement("div", { className: "h-5 bg-skeleton rounded-full flex flex-grow" }))))));
};
//# sourceMappingURL=LoadingState.js.map